import { css } from '@emotion/css';

export const styles = {
  capFormContainer: css({
    maxWidth: '1440px',
  }),

  /* TODO: It appears that we are using this css to avoid rendering the vertical dropdown option in all forms. This should be done in code/logic, not via css. */
  dropdownItemContainer: css({
    '> div': {
      marginTop: '20px',
      marginBottom: '12px',
      minWidth: '250px !important',
      marginRight: '20px',

      '&:first-child': {
        display: 'none',
      },
    },
  }),

  dropdownItemContainerRightStepper: css({
    '> div': {
      marginLeft: '15px',
      marginTop: '5px',
      marginBottom: '3px',
      width: '400px',
    },
  }),

  genericRightStepperItem: css({
    marginLeft: '15px',
  }),

  baseDropdownItem: css({
    paddingTop: '5px',
  }),

  formStepperContainer: css({
    display: 'inline-flex',
    alignItems: 'flex-start',
    width: '100%',
    marginTop: '35px !important',
  }),

  leftCol: css({
    verticalAlign: 'top',
    width: '350px',
    float: 'left',
  }),

  genericTextBox: css({
    marginTop: '6px',
    marginBottom: '10px',
    marginLeft: '15px',
  }),

  yesCheckGreen: css({
    color: 'green',
  }),

  noXRed: css({
    color: 'red',
  }),

  rightCol: css({
    marginLeft: '50px !important',
    width: '1000px',
    height: 'auto',
    float: 'right',
  }),

  title: css({
    marginTop: '25px',
    marginBottom: '5px',
  }),

  activeHeading: css({
    marginLeft: '15px',
    marginTop: '12px',
    marginBottom: '14px',
  }),

  activeSubHeading: css({
    marginLeft: '15px',
    marginTop: '20px',
    marginBottom: '10px',
  }),

  radiodropdownParent: css({
    marginTop: '10px',
  }),

  unorderedListBlock: css({
    margin: '15px 0 0 15px',
    display: 'block',
  }),

  unorderedListBlockContactInformation: css({
    margin: '20px 0 0 0',
    display: 'block',
  }),

  unorderedListContainer: css({
    fontSize: '16px',
    fontWeight: '400px',
    lineHeight: '24px',
  }),

  unorderedList: css({
    margin: '5px 0 0 -10px !important',
  }),

  nextButtonContainer: css({
    width: '90.5%',
    margin: '18px 75px 25px 0',
    '> *': {
      float: 'right',
    },
  }),

  backButtonContainer: css({
    width: '90.5%',
    margin: '18px 10px 0 0',
  }),

  buttonsContainer: css({
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
    marginTop: '50px',
  }),

  saveButton: css({
    margin: '0 10px',
  }),

  rightButtonsContainer: css({
    display: 'inline-flex',
    float: 'right',
  }),

  genericDropdownItem: css({
    paddingTop: '5px',
    display: 'inline-block',
    minWidth: 'fit-content',

    '> div': {
      width: '100%',
    },

    select: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  }),
};
